import { FC } from 'react';

import { BugoData } from '@shared/api/bugo/bugo.interface';
import { Icon } from '@shared/components/icons';
import { Link } from 'react-router-dom';
import wreathImg from 'src/assets/image/wreathImage.png';

interface Props {
  bugo: BugoData;
}

export const FlowerBottomBanner: FC<Props> = function FlowerBottomBanner({
  bugo,
}: Props) {
  const { CaretDown } = Icon();

  return (
    <Link
      to={`/flower-store/?bugoId=${bugo._id}`}
      className="relative grid grid-cols-[minmax(0,1fr)_72px] items-center gap-3 rounded-lg p-4 font-sans theme-bg-5 min-[360px]:grid-cols-[minmax(0,1fr)_88px]"
    >
      <div className="min-w-0 space-y-2 break-keep font-medium">
        <p className="text-13 leading-5">주소 입력 없이 쉽고 간편하게</p>
        <div className="flex items-center gap-1 whitespace-nowrap text-18 font-bold leading-7 min-[360px]:text-20">
          <p>근조화환 보내기</p>
          <CaretDown className="wh-4 shrink-0 -rotate-90 fill-gray-700" />
        </div>
        <div className="text-13 leading-5">
          <p>장례식장으로 당일배송</p>
          <p className="text-12">19시 이전 주문 시</p>
        </div>
      </div>
      {/* 원본의 좌우 투명 여백만 덜어내고, 위아래는 배너에서 4px씩 띄운다. */}
      <div className="h-28 min-w-0">
        <img
          src={wreathImg}
          alt="상품이미지"
          className="absolute right-3 top-1 aspect-[3/5] h-[calc(100%-8px)] w-auto max-w-none object-cover"
        />
      </div>
    </Link>
  );
};
